import * as tslib_1 from "tslib";
import commitChangesToUserOptions from '../mutators/commitChangesToUserOptions';
import { getUserConfiguration } from 'owa-session-store';
import setNotificationSettings from '../services/setNotificationSettings';
export default function saveAppNotificationOptions() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var userOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Save the changes locally
                    commitChangesToUserOptions();
                    userOptions = getUserConfiguration().UserOptions;
                    return [4 /*yield*/, setNotificationSettings(userOptions.NewItemNotify, userOptions.EnableReminders, userOptions.EnableReminderSound)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=saveAppNotificationOptions.js.map